import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";




const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PaymentFailure = () => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [mobileno, setMobileno] = useState("");
    const [userid, setUserid] = useState("");
    const [username, setUsername] = useState("");
        const [plan, setPlan] = useState("");
    
    const [planname, setPlanname] = useState("");
    const [district, setDistrict] = useState("all");
    const [city, setCity] = useState("all");
    const [type, setType] = useState("all");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
        const [userDetails, setUserDetails] = useState(null);
        const [isModalOpen, setIsModalOpen] = useState(false);


             const [isFollowUpModalOpen, setIsFollowUpModalOpen] = useState(false);
                                                                                        const [followUpDate, setFollowUpDate] = useState(moment().format("YYYY-MM-DD"));
                                                                                        const [followUpReason, setFollowUpReason] = useState("");
                            


                        const navigate = useNavigate();
        

    useEffect(() => {
        fetchData();
    }, [startDate, endDate, mobileno, userid, username, planname, district, city, type]);


                                                                                                                                                                                              
    useEffect(() => {
        document.title = 'Payment Failure Report - Calendar Services';
    
        // Initialize the date range picker
        $("#kt_daterangepicker_4").daterangepicker(
          {
            startDate: moment(),
            endDate: moment(),
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment().endOf("month")],
              "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
            },
          },
          (start, end) => {
            setStartDate(start.format("YYYY-MM-DD"));
            setEndDate(end.format("YYYY-MM-DD"));
            $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
          }
        );
    
        // Set initial display value
        $("#kt_daterangepicker_4").html(
          `${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
        );
      }, []);




    const fetchData = async () => {
        setLoading(true);
        try {
            // const response = await axios.post("http://localhost:3036/payment_failure", {
                const response = await axios.post(`${API_BASE_URL}/payment_failure`,{

                startDate,
                endDate,
                mobileno,
                userid,
                username,
                planname,
                district,
                city,
                type,
            });
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


       
  const handleSaveFollowUp = async () => {
    if (!followUpReason) {
      alert("Please enter a follow-up reason.");
      return;
    }

    const loggedInUser = localStorage.getItem("username"); // Fetch the logged-in user

    if (!loggedInUser) {
      alert("Error: No logged-in user found. Please log in again.");
      return;
    }
  
    try {
      const response = await axios.post(`${API_BASE_URL}/save_followup`, {
        userid: userDetails.id,
        followup_date: followUpDate,
        followup_remark: followUpReason,
        cby: loggedInUser // Replace with actual logged-in username from session

      });
  
      alert(response.data.message);
      fetchData(); // Refresh data after saving
      closeFollowUpModal(); // Close the modal
    } catch (error) {
      console.error("Error saving follow-up:", error);
      alert("Failed to save follow-up. Please try again.");
    }
  };

    
    
      const openFollowUpModal = () => {
        setIsFollowUpModalOpen(true);
      };
      
      const closeFollowUpModal = () => {
        setIsFollowUpModalOpen(false);
        setFollowUpDate(moment().format("YYYY-MM-DD")); // Reset to default
        setFollowUpReason(""); // Reset to empty
      };
    

    const handlePlanChange = (e) => {
        const selectedPlan = e.target.value;
        setPlan(selectedPlan);
    
        const planToTypeMapping = {
          "ONE YEAR PLAN+18%(ஐயர்)": "ஐயர்",
          "ONE YEAR PLAN+18%(ஜோதிடர்)": "ஜோதிடர்",
          "ONE YEAR PLAN+18%(வாஸ்து நிபுணர்)": "வாஸ்து நிபுணர்",
          "ONE YEAR PLAN+18%(எண்கணிதம்)": "எண்கணிதம்",

        };
    
        if (planToTypeMapping[selectedPlan]) {
          setType(planToTypeMapping[selectedPlan]);
          setPlanname(selectedPlan.split("+")[0].trim()); // Use only the base plan name for filtering
        } else {
          setType("all");
          setPlanname("all");
        }
      };  


    const handleViewDetails = async (row) => {
        setLoading(true);
        try {
            const payload = row.userid
                ? { userid: row.userid } // Pass userid if available
                : { name: row.name, type: row.type }; // Otherwise, pass name and type
    
            // const response = await axios.post("http://localhost:3036/registered_users/details_name_type", payload);
            const response = await axios.post(`${API_BASE_URL}/registered_users/details_name_type`, payload);

            setUserDetails(response.data);
            setIsModalOpen(true);
        } catch (error) {
            console.error("Error fetching user details:", error);
            alert("Failed to fetch user details.");
        } finally {
            setLoading(false);
        }
    };

      
  const handleDeleteUser = async (userid) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this user?");
    if (!confirmDelete) return;

    try {
        const response = await axios.post(`${API_BASE_URL}/delete_user`, { userid });

        alert(response.data.message);
        fetchData(); // Refresh data after deletion
        closeModal();
    } catch (error) {
        console.error("Error deleting user:", error);
        alert("Failed to delete user. Please try again.");
    }
};



//   const handleViewDetails = async (id) => {
//     try {
//       // const response = await axios.post("http://localhost:3036/registered_users/details", { id });
//       const response = await axios.post(`${API_BASE_URL}/registered_users/details`, { id });

//       setUserDetails(response.data);
//       setIsModalOpen(true);
//     } catch (error) {
//       console.error("Error fetching user details:", error);
//       alert("Failed to fetch user details.");
//     }
//   };



const handleFollowUp = async (userid) => {
    const confirmFollowUp = window.confirm("Are you sure you want to mark this user for follow-up?");
    if (!confirmFollowUp) return;
  
    try {
        const response = await axios.post(`${API_BASE_URL}/update_followup_status`, { userid });
  
        alert(response.data.message);
        fetchData(); // Refresh the data after marking follow-up
        closeModal();
    } catch (error) {
        console.error("Error marking follow-up:", error);
        alert("Failed to mark follow-up. Please try again.");
    }
  };
  
  
  const handleVerifyUser = async (userid) => {
    const confirmVerify = window.confirm("Are you sure you want to verify this user?");
    if (!confirmVerify) return;

    try {
        const response = await axios.post(`${API_BASE_URL}/update_user_status_verify_user`, {
            userid,
            is_verify: 1, // Update is_verify to 1
        });

        alert(response.data);
        fetchData(); // Refresh the data after verification
        closeModal();
    } catch (error) {
        console.error("Error verifying user:", error);
        alert("Failed to verify user. Please try again.");
    }
};


const handleInactivateUser = async (userid) => {
  const confirmInactivate = window.confirm("Are you sure you want to inactivate this user?");
  if (!confirmInactivate) return;

  try {
      const response = await axios.post(`${API_BASE_URL}/update_user_status`, {
          userid,
          is_active: 0,
      });

      alert(response.data);
      fetchData();
      closeModal();
  } catch (error) {
      console.error("Error inactivating user:", error);
      alert("Failed to inactivate user. Please try again.");
  }
};


// const handleEditUser = async (row) => {
// try {
//     const payload = row.userid ? { userid: row.userid } : { name: row.name, type: row.type };

//     const response = await axios.post(`${API_BASE_URL}/registered_users/details_name_type`, payload);

//     // Navigate to the RegisterUser page with the fetched user details
//     navigate("/master/update_user", { state: { userDetails: response.data } });
// } catch (error) {
//     console.error("Error fetching user details:", error);
//     alert("Failed to fetch user details.");
// }
// };




    
const handleEditUser = async () => {
    try {
      if (!userDetails) {
        alert("No user details available for editing.");
        return;
      }
  
      const response = await axios.post(`${API_BASE_URL}/registered_users/details_name_type`, {
        userid: userDetails.id, // Ensure correct ID is passed
      });
  
      // Navigate to update page with fetched user details
      navigate("/master/update_user", { state: { userDetails: response.data } });
    } catch (error) {
      console.error("Error fetching user details:", error);
      alert("Failed to fetch user details.");
    }
  };
    

    const closeModal = () => {
        setIsModalOpen(false);
        setUserDetails(null);
    };


    const columns = [
        { name: "SlNo", selector: (row) => row.slNo, sortable: true },
        {
            name: "Actions",
            cell: (row) => (
                <button
                    onClick={() => handleViewDetails(row)}
                    className="btn btn-warning bg-red-200"
                >
                    View Details
                </button>
            ),
        },        
        //  { name: "Added By", selector: (row) => row.added_by, sortable: true }, // Added By
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        {
            name: "Type",
            selector: (row) => row.type,
            cell: (row) => (
                <span
                    style={{
                        background: row.typeColor,
                        padding: "5px",
                        color: "#fff",
                        borderRadius: "5px",
                    }}
                >
                    {row.type}
                </span>
            ),
            sortable: true,
        },
        { name: "Invoice No", selector: (row) => row.inv_no, sortable: true },
        { name: "Invoice Date", selector: (row) => row.cdate, sortable: true },
        { name: "Plan Amount", selector: (row) => row.actual_amount, sortable: true },
        { name: "Total Paid Amount", selector: (row) => row.TXN_AMOUNT, sortable: true },
        { name: "Plan Name", selector: (row) => row.planname, sortable: true },
        // { name: "Start Date", selector: (row) => row.start_date, sortable: true },
        // { name: "Expiry Date", selector: (row) => row.end_date, sortable: true },
        { name: "Reg Date", selector: (row) => row.adddate, sortable: true },
        // { name: "View Count", selector: (row) => row.viewcount, sortable: true },
        // { name: "Call Count", selector: (row) => row.callcount, sortable: true },
    ];


    const csvHeaders = [
        { label: "SlNo", key: "slNo" },
        { label: "Added By", key: "added_by" },
        { label: "Name", key: "name" },
        { label: "Mobile No", key: "mobileno" },
        { label: "Type", key: "type" },
        { label: "Invoice No", key: "inv_no" },
        { label: "Invoice Date", key: "cdate" },
        { label: "Plan Amount", key: "actual_amount" },
        { label: "Total Paid Amount", key: "TXN_AMOUNT" },
        { label: "Plan Name", key: "planname" },
        { label: "Start Date", key: "start_date" },
        { label: "Expiry Date", key: "end_date" },
        { label: "Reg Date", key: "adddate" },
        { label: "View Count", key: "viewcount" },
        { label: "Call Count", key: "callcount" },
    ];

    
    

    const openModel = (id) => {
        // Logic to open modal and fetch user details
    };

    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white">
            <h2 className="text-2xl font-bold mb-6 text-center">Payment Failure Report</h2>
               <div className="flex justify-center items-center gap-2 mb-6">
                                                                    <div className="mb-3">
                                                                                                    <div className="text-center mb-6 flex items-center space-x-2 justify-center">
                                                                                                      <div id="kt_daterangepicker_4" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
                                                                                                        {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
                                                                                                      </div>
                                                                                        
                                                                                                      <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        className="h-5 w-5 text-gray-500"
                                                                                                        fill="none"
                                                                                                        viewBox="0 0 24 24"
                                                                                                        stroke="currentColor"
                                                                                                      >
                                                                                                        <path
                                                                                                          strokeLinecap="round"
                                                                                                          strokeLinejoin="round"
                                                                                                          strokeWidth={2}
                                                                                                          d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                                                                                                        />
                                                                                                      </svg>
                                                                                                    </div>
                                                                                                  </div>
                                                                                                  </div>
                                                                                                  
                                                                                                  <div className="flex justify-center items-center gap-6 mb-6">
                                                                    <div className="flex flex-col items-center">
                                                                        <label htmlFor="district" className="mb-1 font-medium">
                                                                            District:
                                                                        </label>
                                                                        <select
                                                                            id="district"
                                                                            value={district}
                                                                            onChange={(e) => setDistrict(e.target.value)}
                                                                            className="border border-gray-300 rounded-md p-2"
                                                                        >
                                                                            <option value="all">மாவட்டத்தை தேர்வு செய்க</option>
                                                            <option value="அரியலூர்">அரியலூர்</option>
                                                            <option value="இராமநாதபுரம்">இராமநாதபுரம்</option>
                                                            <option value="ஈரோடு">ஈரோடு</option>
                                                            <option value="கடலூர்">கடலூர்</option>
                                                            <option value="கன்னியாகுமரி">கன்னியாகுமரி</option>
                                                            <option value="கரூர்">கரூர்</option>
                                                            <option value="கள்ளக்குறிச்சி">கள்ளக்குறிச்சி</option>
                                                            <option value="காஞ்சிபுரம்">காஞ்சிபுரம்</option>
                                                            <option value="காரைக்கால்">காரைக்கால்</option>
                                                            <option value="கிருஷ்ணகிரி">கிருஷ்ணகிரி</option>
                                                            <option value="கோயம்புத்தூர்">கோயம்புத்தூர்</option>
                                                            <option value="சிவகங்கை">சிவகங்கை</option>
                                                            <option value="செங்கல்பட்டு">செங்கல்பட்டு</option>
                                                            <option value="சென்னை">சென்னை</option>
                                                            <option value="சேலம்">சேலம்</option>
                                                            <option value="தஞ்சாவூர்">தஞ்சாவூர்</option>
                                                            <option value="தர்மபுரி">தர்மபுரி</option>
                                                            <option value="திண்டுக்கல்">திண்டுக்கல்</option>
                                                            <option value="திருச்சிராப்பள்ளி">திருச்சிராப்பள்ளி</option>
                                                            <option value="திருநெல்வேலி">திருநெல்வேலி</option>
                                                            <option value="திருப்பத்தூர்">திருப்பத்தூர்</option>
                                                            <option value="திருப்பூர்">திருப்பூர்</option>
                                                            <option value="திருவண்ணாமலை">திருவண்ணாமலை</option>
                                                            <option value="திருவள்ளூர்">திருவள்ளூர்</option>
                                                            <option value="திருவாரூர்">திருவாரூர்</option>
                                                            <option value="தூத்துக்குடி">தூத்துக்குடி</option>
                                                            <option value="தென்காசி">தென்காசி</option>
                                                            <option value="தேனி">தேனி</option>
                                                            <option value="நாகப்பட்டினம்">நாகப்பட்டினம்</option>
                                                            <option value="நாமக்கல்">நாமக்கல்</option>
                                                            <option value="நீலகிரி">நீலகிரி</option>
                                                            <option value="புதுக்கோட்டை">புதுக்கோட்டை</option>
                                                            <option value="புதுச்சேரி">புதுச்சேரி</option>
                                                            <option value="பெரம்பலூர்">பெரம்பலூர்</option>
                                                            <option value="மதுரை">மதுரை</option>
                                                            <option value="மயிலாடுதுறை">மயிலாடுதுறை</option>
                                                            <option value="மஹி">மஹி</option>
                                                            <option value="யானம்">யானம்</option>
                                                            <option value="ராணிப்பேட்டை">ராணிப்பேட்டை</option>
                                                            <option value="விருதுநகர்">விருதுநகர்</option>
                                                            <option value="விழுப்புரம்">விழுப்புரம்</option>
                                                            <option value="வேலூர்">வேலூர்</option>
                                                                                </select>
                                                                    </div>
                                                                    <div className="flex flex-col items-center">
                                                                        <label htmlFor="type" className="mb-1 font-medium">
                                                                        Type:
                                                                        </label>
                                                                        <select
                                                                            id="type"
                                                                            value={type}
                                                                            onChange={(e) => setType(e.target.value)}
                                                                            className="border border-gray-300 rounded-md p-2"
                                                                        >
                                                                            <option value="all">வகையை தேர்வு செய்க</option>
                                                                            <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                                                                            <option value="மற்ற ஆன்மிக சேவைகள்">மற்ற ஆன்மிக சேவைகள்</option>
                                                                            <option value="ஜோதிடர்">ஜோதிடர்</option>
                                                                            <option value="ஐயர்">ஐயர்</option>
                                                                            <option value="எண்கணிதம்">எண்கணிதம்</option>
                                                                            <option value="அலங்காரம் செய்பவர்others">அலங்காரம் செய்பவர்others</option>
                                                                            <option value="சிற்பி / ஸ்தபதி- others">சிற்பி / ஸ்தபதி- others</option>
                                                                            <option value="others">others</option>
                                                                            <option value="ஆன்மீக சொற்பொழிவாளர்- others">ஆன்மீக சொற்பொழிவாளர்- others</option>
                                                                            <option value="விபூதி தயாரிப்பவர்- others">விபூதி தயாரிப்பவர்- others</option>
                                                                            <option value="சிர்பி-others">சிர்பி-others</option>
                                                                            <option value="திருவிழா அலங்காரம் செய்பவர்- others">திருவிழா அலங்காரம் செய்பவர்- others</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="flex flex-col items-center">
                              <label htmlFor="type" className="mb-1 font-medium">
                              Plan:
                              </label>
                              <select
    id="plan"
    value={plan}
    onChange={handlePlanChange}
    className="border border-gray-300 rounded-md p-2"
>
    <option value="all">PLan தேர்வு செய்க</option>
    <option value="ONE YEAR PLAN+18%(ஐயர்)">ONE YEAR PLAN+18%(ஐயர்)</option>
    <option value="ONE YEAR PLAN+18%(ஜோதிடர்)">ONE YEAR PLAN+18%(ஜோதிடர்)</option>
    <option value="ONE YEAR PLAN+18%(வாஸ்து நிபுணர்)">ONE YEAR PLAN+18%(வாஸ்து நிபுணர்)</option>
    <option value="ONE YEAR PLAN+18%(எண்கணிதம்)">ONE YEAR PLAN+18%(எண்கணிதம்)</option>
</select>

                          </div>
                                                                </div>
                <div className="flex justify-end mb-5">
                                                                                       <CSVLink
                                                                                           data={data}
                                                                                           headers={csvHeaders}
                                                                                           filename="Expire_search_list.csv"
                                                                                           className="bg-green-500 text-white px-4 py-2 rounded-md"
                                                                                       >
                                                                                           Export to Excel
                                                                                       </CSVLink>
                                                                                   </div>


            {loading ? (
                <p className="text-center mt-4">Loading...</p>
            ) : (
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    highlightOnHover
                    className="mt-6"
                />
            )}
               {isModalOpen && userDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div
                className="bg-white p-6 rounded-lg max-w-4xl w-full overflow-y-auto"
                style={{ maxHeight: "80vh" }}
            >
                <h3 className="text-xl font-bold mb-4 text-center text-blue-700">User Details</h3>
                <div className="grid grid-cols-2 gap-4">
                    <p><strong>Name:</strong> {userDetails.name}</p>
                    <p><strong>Mobile No:</strong> <span style={{ color: "green" }}>{userDetails.mobileNo}</span></p>
                    <p><strong>Gender:</strong> {userDetails.gender || "-"}</p>
                    <p><strong>Type:</strong> {userDetails.type}</p>
                    <p><strong>Category:</strong> {userDetails.category || "-"}</p>
                    <p><strong>District:</strong> {userDetails.district}</p>
                    <p><strong>City:</strong> {userDetails.city}</p>
                    <p><strong>Education:</strong> {userDetails.education}</p>
                    <p><strong>Experience:</strong> {userDetails.experience} years</p>
                    <p><strong>Address:</strong> {userDetails.address || "-"}</p>
                    {/* <p><strong>E-mail:</strong> {userDetails.email || "-"}</p> */}
                    <p><strong>Other Details:</strong> {userDetails.otherDetails || "-"}</p>
                    <p><strong>Web Link:</strong> <a href={userDetails.webLink} target="_blank" rel="noopener noreferrer">{userDetails.webLink}</a></p>
                    <p><strong>YouTube Link:</strong> <a href={userDetails.youtubeLink} target="_blank" rel="noopener noreferrer">{userDetails.youtubeLink}</a></p>
                    <p><strong>Facebook Link:</strong> <a href={userDetails.facebookLink} target="_blank" rel="noopener noreferrer">{userDetails.facebookLink}</a></p>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-4">
                    
                    <div>
                        
                        <strong>Image 1:</strong>
                        {userDetails.image1 && (
                            <img
                            src={`${API_BASE_URL}/${userDetails.image1}`} 
                                alt="Image 1"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Image 2:</strong>
                        {userDetails.image2 && (
                            <img
                            src={`${API_BASE_URL}/${userDetails.image2}`} 
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>ID proof</strong>
                        {userDetails.idproof && (
                            <img
                                src={userDetails.idproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Address Proof</strong>
                        {userDetails.addressproof && (
                            <img
                                src={userDetails.addressproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Other Proof</strong>
                        {userDetails.otherproof && (
                            <img
                                src={userDetails.otherproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                </div>

                <div className="mt-6 text-center">
                <button
    onClick={() => handleEditUser(userDetails)}
    className="btn text-white"
    style={{ backgroundColor: "#007bff", margin: "0 0.5rem", padding: "0.5rem 1rem" }}
>
    Edit
</button>
<button
    onClick={() => handleVerifyUser(userDetails.id)}
    className="btn text-white"
    style={{ backgroundColor: "#28a745", margin: "0 0.5rem", padding: "0.5rem 1rem" }}
>
    Verify
</button><button
    onClick={() => handleInactivateUser(userDetails.id)}
    className="btn text-white"
    style={{ backgroundColor: "#ffc107", margin: "0 0.5rem", padding: "0.5rem 1rem" }}
>
    Inactive
</button>
<button  
// onClick={() => handleDeleteUser(userDetails.id)} 
className="btn text-white" style={{ backgroundColor: "#dc3545", margin: "0 0.5rem", padding: "0.5rem 1rem",  }}>Delete</button>
<button
  onClick={openFollowUpModal}
  className="btn text-white"
  style={{ backgroundColor: "#fd7e14", margin: "0 0.5rem", padding: "0.5rem 1rem" }}
>
  Follow Up
</button>
                </div>

                <div className="mt-4 text-center">
                    <button onClick={closeModal} className="btn btn-secondary text-red-500">Close</button>
                </div>
            </div>
        </div>
    )}

               
{isFollowUpModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-6 rounded-lg max-w-md w-full">
      <h3 className="text-xl font-bold mb-4 text-center text-blue-700">Follow Up</h3>
      <div className="mb-4">
        <label htmlFor="followUpDate" className="block mb-1">Follow Up Date:</label>
        <input
          id="followUpDate"
          type="date"
          value={followUpDate}
          onChange={(e) => setFollowUpDate(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full"
        />
      </div>
      <div className="mb-4">
        <label htmlFor="followUpReason" className="block mb-1">Follow Up Reason:</label>
        <textarea
          id="followUpReason"
          value={followUpReason}
          onChange={(e) => setFollowUpReason(e.target.value)}
          placeholder="Enter follow-up reason..."
          className="border border-gray-300 rounded-md p-2 w-full"
        />
      </div>
      <div className="flex justify-center">
        <button
          onClick={handleSaveFollowUp}
          className="btn text-white"
          style={{ backgroundColor: "#007bff", padding: "0.5rem 1rem" }}
        >
          Save
        </button>
        <button
          onClick={closeFollowUpModal}
          className="btn text-white"
          style={{ backgroundColor: "#dc3545", marginLeft: "0.5rem", padding: "0.5rem 1rem" }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
        </div>
    );
};

export default PaymentFailure;